import Histogram from "./Histogram";
import XModal from "../../../components/common/XModal";
import useDistributionHistogramModal from "./hooks/useDistributionHistogramModal";

const summaryHeadingClasses = "flex justify-center text-2xl font-semibold text-content";

const DistributionHistogramModal = ({ closeModal, openModal, distribution }) => {
    const { histogramData, metricLabel, summary } = useDistributionHistogramModal({ openModal, distribution });

    return (
        <XModal
            isOpen={openModal}
            title={distribution?.companyName}
            onClose={closeModal}
            size="lg"
        >
            <h5 className={summaryHeadingClasses}>{summary}</h5>
            <div className="h-[60vh]">
                <Histogram selectedDataKey={metricLabel} data={histogramData} />
            </div>
        </XModal>
    );
};

export default DistributionHistogramModal;
